module.exports = __webpack_public_path__ + "img/perlinFbm.c9a8c996.jpg";